import {moduleInfo, modulesType, storeType,} from "./content.types"
import {SystemGlobalsService} from "../system-globals.service";
import {Preset} from "./modules/schedule/schedule-types";

export class DataSource {

  globals: SystemGlobalsService = null;

  store: storeType = {
    modules: new Map<number, modulesType>(),
    filteredResults: [],
    network: {},
    selectedModule: null,
    selectedModules: new Map<number, modulesType>(),
    filters: [],
    settings: null,
    instructors: [],
    categories: [],
    authors: [],
    moduleInfo: new moduleInfo(),
    groups: [],
    tags: null,
    searchTerm: null,
    versions: [],
    currentInfoText: {title: "", text: ""},
    searchTermResults: [],
    searchResults: [],
    modulePresets: [],
  }

  setAllModulesStore(modules: modulesType[]) {

    let favIds = [];

    modules['favorites'].map((c) => {
      favIds.push(c['CourseFavorite']['courseID']);
    })

    modules['courses'].map((c) => {

      c["Course"]["isFavorite"] = favIds.includes(c["Course"].courseID);
      c["Course"]["categories"] = c["CourseCategory"];

      let merge = Object.assign({}, c["Course"], {moduleVersions: c["moduleVersions"]});
      this.store.modules.set(c["Course"].courseID, new modulesType(merge));
    });

    this.remapGroups(modules["moduleGroups"]);
  }

  setSearchResultsStore(results, callback: Function) {
    this.store.searchResults = [];
    let collection = []
    if (results.length == 0) {
      this.store.searchResults = [new modulesType()];
    } else {
      for (let id in results) {
        let content = this.store.modules.get(parseInt(id))
        if (content) {
          content["content"] = Object.values(results[id]["data"]);
          collection.push(this.store.modules.get(parseInt(id)));
        }
        this.store.searchResults = collection;


      }
    }

    callback(this.store.searchResults);
  }

  public remapGroups(groupsObj) {

    let groups = [];
    let canDelete = [];
    for (let group in groupsObj) {

      this.store.modules.forEach((m) => {
        if (m.groupIds.includes(+group)) {
          canDelete.push(+group);
        }
      })
      groups.push({id: +group, name: groupsObj[group], canDelete: !canDelete.includes(+group)})
    }
    this.store.groups = groups;
  }

  setFilters() {
    this.store.filters = {
      Groups: {
        data: [{
          catShort: "ddd",
          id: 1147,
          memoID: 0,
          name: "All",
          networkId: 106,
          value: 1147
        },

          {
            catShort: "ddd",
            id: 1147,
            memoID: 0,
            name: "Manufacturing",
            networkId: 106,
            value: 1147
          }

        ], type: "checkmark"
      }
    }
  }


  fetchFilterModules(query, callback) {

    let moduleArray = Array.from(this.store.modules.values());

    switch (query) {
      case 'drafts' : {
        this.setFilteredResults(moduleArray.filter((e) => e.status == 0 && (e.pptImportStatus == 0)));
        callback()
      }
        break;
      case 'favorites' : {
        this.setFilteredResults(moduleArray.filter((e) => e.isFavorite && e.status != 2));
        callback()
      }
        break;
      case 'processing' : {
        this.setFilteredResults(moduleArray.filter((e) => e.status == 0 && e.pptImportStatus == "Queued"));
        callback()
      }
        break;

      case 'published' : {
        this.setFilteredResults(moduleArray.filter((e) => e.status == 1));
        callback()
      }
        break;
      case 'archived' : {
        this.setFilteredResults(moduleArray.filter((e) => e.status == 2));
        callback()
      }
      break;
      case 'all' : {
        let role = (this.globals.constants.userRole != 5) ? 0 :  1 ;
        let results = moduleArray.filter((e) => e.status == 2 || e.status == 1 || ( e.status == role));
        this.setFilteredResults(results.sort((a, b) =>a.status - b.status));
        callback()
      }
    }
  }

  setFilteredResults(data) {
    this.store.filteredResults = data;
  }


  unsetSelectedModules() {
    this.store.selectedModules.forEach((mod) => {
      this.store.modules.get(mod.courseID)['checked'] = false;
    });
    this.store.selectedModules.clear();
  }

}
